import React, { useState } from 'react';
import './MerchantAccountDetailsSubCard.scss';
import { VIEW_LOCATIONS } from '../../../constants/Admin/MerchantAccountConstants';
import LocationsModal from '../../../components/Admin/createaccount/locationsmodal/LocationsModal';
import{ selectLocations, selectedBrandId } from '../../../redux/saga/adminFlow/merchantInfoSelector';
import { useSelector,useDispatch } from 'react-redux';
import { getViewLocationDetailsRequest } from '../../../redux/actions/transactionActions';

const  MerchantAccountDetailsSubCard = ({SUBHEADER1, HEADER_TEXT1, SUBHEADER2, HEADER_TEXT2 }) => {

	const dispatch = useDispatch();
	const [modalOpen, setModalOpen] = useState(false);
	const locationscount = useSelector(selectLocations);
	const selectedbrandId = useSelector(selectedBrandId);

	const handleOpenModal = () => {
		if (selectedbrandId.brandid) {
            dispatch(getViewLocationDetailsRequest(selectedbrandId.brandid));
        }
		setModalOpen(true);
  	};
	const handleCloseModal = () => {
		setModalOpen(false);
	};

	return (
		<>
			<div className='merchantAccountDetailsSubCard-content'>
				<div>
					<div className='merchantAccountDetailsSubCard-content-section'> 
						<p className='merchantAccountDetailsSubCard-content-subheader'> {SUBHEADER1}</p>
						{locationscount?.locations ?
							<>
								<p className='merchantAccountDetailsSubCard-content-header-text view-locations' data-testid='view locations' onClick={handleOpenModal}
								>{VIEW_LOCATIONS} ({locationscount.locations})
								</p>
								<LocationsModal open={modalOpen} onClose={handleCloseModal} />
							</>
							:
							<p className='merchantAccountDetailsSubCard-content-header-text'>{HEADER_TEXT1}</p>
						}
						<p className='merchantAccountDetailsSubCard-content-subheader'>{SUBHEADER2}</p>
						<p className='merchantAccountDetailsSubCard-content-header-text'>{HEADER_TEXT2}</p>
					</div>
				</div>
			</div>
		</>)
}

 export default MerchantAccountDetailsSubCard;
